import MoneyBackImage from 'images/having-troubles-modal-bg.jpg';
import React from 'react';
import { Button } from 'mui';

const ModalHavingTrouble: React.FC<{ setHavingTroubleModalOpen: React.SetStateAction<any> }> = ({
  setHavingTroubleModalOpen,
}) => (
  <div className="referral-source-modal__body">
    <div className="referral-source-modal__content">
      <h5 className="mb-4">I{"'"}m having trouble taking or uploading a picture</h5>
      <p className="mb-4">
        If you started your visit from within Facebook, Instagram or another application, it is sometimes not possible
        to access the camera to take a photo for your visit. Try resuming your visit in another browser like Safari or
        Chrome, or on your desktop computer.
      </p>

      <p className="mb-4">
        If you have tried to submit your photos and it seems like nothing is happening, this can sometimes come down to
        the small print. Our website will quickly guide you through the process and request several photos in a row.
        Please read each page carefully, as after every refresh we will ask you for a different photo.
      </p>

      <p>
        If the problem persists please contact our concierge team by emailing{' '}
        <a href="mailto:support@maximustribe.com">support@maximustribe.com</a> or using the blue chat box on the bottom
        right of your screen.
      </p>
      <Button className="mt-8" onClick={() => setHavingTroubleModalOpen(false)}>
        Close
      </Button>
    </div>
    <img src={MoneyBackImage} className="referral-source-modal__image" alt="" />
  </div>
);

export default ModalHavingTrouble;
